
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AgentTemplate } from '@/data/agentTemplates';

interface TemplateSelectorProps {
  selectedTemplate: string;
  onTemplateChange: (templateId: string) => void;
  filteredTemplates: AgentTemplate[];
  selectedCategory: string;
  selectedTemplateFull?: AgentTemplate;
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  selectedTemplate,
  onTemplateChange,
  filteredTemplates,
  selectedCategory,
  selectedTemplateFull
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="templateSelect">Select Template</Label>
      <Select value={selectedTemplate} onValueChange={onTemplateChange}>
        <SelectTrigger id="templateSelect" className="border-[#0EA5E9]/30">
          <SelectValue placeholder="Choose a template" />
        </SelectTrigger>
        <SelectContent>
          {selectedCategory === 'custom' ? (
            <SelectItem value="custom">Custom SOP Agent</SelectItem>
          ) : (
            filteredTemplates.map(template => (
              <SelectItem key={template.id} value={template.id}>
                {template.name}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
      {selectedTemplateFull && (
        <p className="text-sm text-gray-600 mt-1">{selectedTemplateFull.description}</p>
      )}
    </div>
  );
};

export default TemplateSelector;
